// A single looping background bed for an entire run. Owned at the run level
// (ProtocolPlayer) so it starts on the first buffer and plays continuously
// through every segment and inter-segment buffer to the end — it never
// restarts or drops out between segments. Streams via an <audio> element
// (no giant AudioBuffer), so it is instant and mobile-safe.
export class BackgroundBed {
  private el: HTMLAudioElement | null = null;

  // Start the bed if it isn't already playing. Idempotent: calling it again
  // while a bed is active keeps the current playback going (no restart).
  play(url: string, volume: number): void {
    if (this.el) return;
    try {
      const el = new Audio(url);
      el.loop = true;
      el.preload = 'auto';
      el.volume = Math.min(1, Math.max(0, volume));
      this.el = el;
      void el.play().catch(() => {});
    } catch {
      /* element unavailable: silently no background */
    }
  }

  // Pause/resume the bed with the rest of the session (e.g. the run's Pause
  // control) without tearing it down, so it keeps its position.
  pause(): void {
    try { this.el?.pause(); } catch { /* ignore */ }
  }

  resume(): void {
    try { void this.el?.play().catch(() => {}); } catch { /* ignore */ }
  }

  stop(): void {
    if (this.el) {
      try {
        this.el.pause();
        this.el.src = '';
      } catch {
        /* ignore */
      }
      this.el = null;
    }
  }
}
